import React from 'react';

import useClassy from '@core/hooks/useClassy';

import type { FlexProps } from '@ui/Flex';
import Flex from '@ui/Flex';

import classes from './style.module.scss';

export interface ModalFooterProps extends Pick<FlexProps, 'align' | 'gap' | 'justify'> {
  border?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export default function ModalFooter({
  align,
  border = true,
  children,
  className,
  justify = 'end',
  ...attrs
}: ModalFooterProps) {
  const bem = useClassy(classes, 'Modal-Footer');

  return (
    <Flex
      align={align}
      className={bem('&', border && '_border', className)}
      gap="sm"
      justify={justify}
      tag="footer"
      {...attrs}
    >
      {children}
    </Flex>
  );
}
